module.exports = __webpack_public_path__ + "img/txt.13e74268.png";